import Link from 'next/link';
import React, { Component, Fragment } from 'react';
const formatCurrency = require('format-currency');
import { getProductServicesArray } from '@src/functions/getProductServicesArray';
import axios from 'axios';
import Image from 'next/image';
import ReactTooltip from 'react-tooltip';

import AddToCartSelector from '../../product/AddToCartSelector';
import CampaignBanner from '../../product/CampaignBanner';
import ProviderDetails from '../../product/ProviderDetails';

class Product extends Component {
	constructor(props) {
		super(props);
		this.productBox = React.createRef();
		this.state = {
			providerLoading: false,
			showProviderDetails: false,
			providerLat: null,
			providerLng: null,
			productBoxWidth: 0,
			productBoxHeight: 0,
			open: false,
			stock: 'In Stock',
			quantity: 1,
			activeIndex: 0,
			image: '',
			selectedServiceIndex: 0,
			forceRender: false,
		};
	}

	componentDidMount() {
		this.setState({
			productBoxWidth: this.productBox.current.offsetWidth,
			productBoxHeight: this.productBox.current.offsetHeight,
		});
	}

	onClickHandle(img) {
		this.setState({ image: img });
	}

	minusQty = () => {
		if (this.state.quantity > 1) {
			this.setState({ stock: 'In Stock' });
			this.setState({ quantity: this.state.quantity - 1 });
		}
	};

	plusQty = () => {
		if (this.props.product.stock >= this.state.quantity) {
			this.setState({ quantity: this.state.quantity + 1 });
		} else {
			this.setState({ stock: 'Out of Stock' });
		}
	};
	changeQty = e => {
		this.setState({ quantity: parseInt(e.target.value) });
	};

	renderServices = serviceArray => {
		return <div>test</div>;
	};

	async BuyNow(item, quantity) {
		await this.props.onAddToCartClicked(item, quantity);
	}

	showProviderDetails = () => {
		this.setState({
			providerLoading: true,
		});
		const { Latitude, Longitude } = this.props.product.selectedProviderService.providerId;
		const { ProviderId } = this.props.product.selectedProviderService.providerId;

		if (ProviderId && Latitude) {
			let _this = this;
			let url = `https://api.marketring-api.com/v1/providerlocations/${ProviderId}?GoogleData=true&lat=${Latitude}&lng=${Longitude}`;
			var result = axios
				.get(url, { crossdomain: true })
				.then(response => {
					_this.setState({
						providerDetails: response.data,
						providerLoading: false,
						showProviderDetails: true,
					});
				})
				.catch(error => {
					return null;
				});
			return result;
		} else {
			return null;
		}
	};

	render() {
		var {
			product,
			symbol,
			applicationSlug,
			onAddToCartClicked,
			onAddToWishlistClicked,
			onAddToCompareClicked,
			isRelated,
			provider,
			index,
			cartlist,
			externalrequest,
			reviews,
		} = this.props;
		const orderIndex = index + 1;
		const specificIndex = orderIndex % 4 === 0;

		var { serviceArray, selectedServiceIndex, optionalServiceArray } = getProductServicesArray(
			product,
			this.state.selectedServiceIndex,
			provider,
			externalrequest
		);

		var IsAvailable = true;

		if (serviceArray.length == 0) {
			IsAvailable = false;
		}

		var related = 'col-xl-3 col-md-6 col-grid-box';

		if (isRelated ? isRelated : false) {
			related = 'col-grid-box';
		}
		var productUrl = `/product/${product.urlSlug}`;
		var hrefUrl = `/product/[productid]`;

		if (applicationSlug != undefined) {
			productUrl = `${productUrl}/${applicationSlug}`;
			hrefUrl = `${hrefUrl}/[crossreferenceid]`;
		}

		product.returnURL = productUrl;
		const { open } = this.state;
		const imageUrl = product
			? product.productPictures.length > 0
				? product.productPictures[0].imageUrl
				: require('../../../static/images/dummy.png')
			: '';

		const providerMsrp = product?.selectedProviderService?.providerId
			? Math.round(product.selectedProviderService.providerId.Price * 1.15, 2)
			: undefined;

		const msrp = Math.round(product.price * 1.15, 2);

		return typeof product != 'undefined' ? (
			<Fragment>
				<ReactTooltip />
				<div
					onMouseLeave={() => this.setState({ showProviderDetails: false })}
					className={`product-box-container group`}>
					{/* Show/hide via both DOM and css */}
					{this.state.showProviderDetails && (
						<ProviderDetails
							reviews={reviews}
							specificIndex={specificIndex}
							optionalServiceArray={optionalServiceArray}
							lat={product.selectedProviderService.providerId.Latitude}
							lng={product.selectedProviderService.providerId.Longitude}
							show={this.state.showProviderDetails}
							data={this.state.providerDetails}
							width={this.state.productBoxWidth}
							height={this.state.productBoxHeight}
							left={this.state.productBoxWidth + 30}
							close={() =>
								this.setState({
									showProviderDetails: false,
								})
							}
						/>
					)}

					<div
						className={`product-box ${product.isFeatured || product.isRecommended ? 'promoted' : ''}`}
						ref={this.productBox}>
						{product.isRecommended ? (
							<span className="featured-text recommended">Recommended</span>
						) : (
							<span className="featured-text">Featured</span>
						)}

						<CampaignBanner campaigns={product.campaigns} />

						<Link href={hrefUrl} as={productUrl}>
							<a>
								<div className="has-overlay">
									<div className="overlay">
										<div className="inner">
											<i className="fad fa-link fa-2x"></i>
											<h6>Click Here for More Details</h6>
										</div>
									</div>
									<div className="img-wrapper">
										<div className="front">
											<Image layout="fill" objectFit="contain" src={imageUrl} alt="" />
										</div>
									</div>

									<div className="product-details">
										<div className="text-content">
											<h6>{product.name}</h6>
											<p>{product.shortDescription}</p>
										</div>

										<div className="price-content">
											<small className="free-installation">
												<span>
													{product.priceTerm
														? product.priceTerm
														: product.groupMessage
														? 'Online Only Price'
														: ''}
												</span>
											</small>
											<del>
												<span className="money">
													{symbol}
													{formatCurrency(providerMsrp || msrp)}
												</span>
											</del>
											<br />
											<h4>
												{symbol}
												{formatCurrency(
													product?.selectedProviderService?.providerId?.Price || product.price
												)}
											</h4>
											{product.groupMessage && (
												<div className="indicator ">
													<div className="graphic">
														<i
															style={{
																left:
																	product.groupMessage === 'Ultimate'
																		? '85%'
																		: product.groupMessage === 'Best'
																		? '70%'
																		: product.groupMessage === 'Better'
																		? '50%'
																		: product.groupMessage === 'Good'
																		? '30%'
																		: product.groupMessage === 'Lowest'
																		? '10%'
																		: '85%',
															}}
															className="fad fa-triangle"></i>
														<div
															className="square"
															style={{
																left:
																	product.groupMessage === 'Ultimate'
																		? '90%'
																		: product.groupMessage === 'Best'
																		? '80%'
																		: product.groupMessage === 'Better'
																		? '70%'
																		: product.groupMessage === 'Good'
																		? '60%'
																		: product.groupMessage === 'Lowest'
																		? '50%'
																		: '85%',
															}}></div>
													</div>
													<span>{product.groupMessage ? product.groupMessage : ''}</span>
												</div>
											)}
										</div>
									</div>
									<p className="disclaimer">
										Order Today - Get Today{' '}
										{product.warranty && `with ${product.warranty} warranty`}.{' '}
										 
									</p>
								</div>
							</a>
						</Link>

						<div className="available-services">
							{serviceArray.length > 0 && !this.props.isUpdating ? (
								<AddToCartSelector
									reviews={reviews}
									cartlist={cartlist}
									compact
									optionalServiceArray={optionalServiceArray}
									serviceArray={serviceArray}
									selectedServiceIndex={selectedServiceIndex}
									item={product}
									addToWishlistClicked={onAddToWishlistClicked}
									addToCartClicked={onAddToCartClicked}
									setSelectedProvider={this.props.setSelectedProvider}
									showProviderDetails={this.showProviderDetails}
									providerLoading={this.state.providerLoading}
									provider={provider}
									symbol={this.props.symbol}
									forceState={this.props.forceState}
									externalrequest={this.props.externalrequest}
								/>
							) : (
								<p className="not-available-text">
									{this.props.isUpdating
										? 'Updating Locations - Please Wait'
										: 'Not Available for your location'}
								</p>
							)}
						</div>
					</div>
				</div>
			</Fragment>
		) : (
			<div className="col-xl-3 col-md-6 col-grid-box">
				<span />
			</div>
		);
	}
}

export default Product;
